import modelSingleton from '@pcln/fly-model'

const Model = modelSingleton()

const flyDetailDeeplinkModel = new Model()

// Clear the model of all properties
flyDetailDeeplinkModel.clear = function() {
  this.params = {}
}

export { flyDetailDeeplinkModel }